import { render, staticRenderFns } from "./subjectPage.vue?vue&type=template&id=885c1a30&"
import script from "./subjectPage.vue?vue&type=script&lang=js&"
export * from "./subjectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports